const API_URL = import.meta.env.VITE_API_URL ?? "http://127.0.0.1:8000";

function getToken(): string | null {
  return localStorage.getItem("guardians_token");
}

export function setToken(token: string): void {
  localStorage.setItem("guardians_token", token);
}

export function clearToken(): void {
  localStorage.removeItem("guardians_token");
}

async function request<T>(path: string, opts: RequestInit = {}): Promise<T> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API_URL}${path}`, { ...opts, headers });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail ?? `Error ${res.status}`);
  }
  return res.json();
}

// Auth
export async function register(username: string, email: string, password: string) {
  return request<{ id: number; username: string; token: string; has_chosen_creatures: boolean }>(
    "/auth/register", { method: "POST", body: JSON.stringify({ username, email, password }) }
  );
}

export async function login(loginValue: string, password: string) {
  return request<{ id: number; username: string; token: string; has_chosen_creatures: boolean }>(
    "/auth/login", { method: "POST", body: JSON.stringify({ login: loginValue, password }) }
  );
}

export async function getMe() {
  return request<{ id: number; username: string; has_chosen_creatures: boolean }>("/auth/me");
}

// Creatures
export async function generateCreatures() {
  return request<{ session_id: string; creatures: any[] }>(
    "/creatures/generate", { method: "POST" }
  );
}

export async function chooseCreatures(sessionId: string, indices: number[]) {
  return request<{ creatures: any[] }>(
    "/creatures/choose", { method: "POST", body: JSON.stringify({ session_id: sessionId, indices }) }
  );
}

export async function getMyCreatures() {
  return request<{ creatures: any[] }>("/creatures/mine");
}

// Combat
export async function startCombat(creatureId: number) {
  return request<any>("/combat/start", { method: "POST", body: JSON.stringify({ creature_id: creatureId }) });
}

export async function combatAction(combatId: string, action: string, attackId?: number, switchTo?: number) {
  return request<any>("/combat/action", {
    method: "POST",
    body: JSON.stringify({ combat_id: combatId, action, attack_id: attackId, switch_to: switchTo }),
  });
}

export async function healAll() {
  return request<any>("/combat/heal", { method: "POST" });
}
